import { useState } from "react";
import moment from "moment";
import { MDBRow } from "mdb-react-ui-kit";
import { Icon } from "@iconify/react";

//primereact
import { InputSwitch } from "primereact/inputswitch";
import { Calendar } from "primereact/calendar";

//component
import ListingTable from "../../../components/modal/listingTable";

export default function TransationListing({
  length,
  start,
  listingData,
  totalRecords,
  displayRecords,
  setSearch,
  setOrder,
  setLength,
  setStart,
  setHandleApplyFilter,
  getListing,
}) {
  const [date, setDate] = useState(new Date());
  const badgeBodyTemplate = (listingData) => {
    return <span>{parseFloat(listingData.amount).toFixed(2)}</span>;
  };
  const columns = [
    { selectionMode: "multiple", headerStyle: "3em" },
    { field: "no", header: "No " },
    { field: "paid_at", header: "Paid on " },
    { field: "reference_no", header: "Booking ID" },

    {
      field: "username",
      header: "Username",
    },
    ,
    { field: "amount", header: "Amount", body: badgeBodyTemplate },

    // { field: "transaction_id", header: "Detail" },
  ];

  return (
    <div className="listing-container">
      <ListingTable
        title="Reload Transaction Report"
        data={listingData}
        columns={columns}
        setSearchValue={setSearch}
        setHandleApplyFilter={setHandleApplyFilter}
        setOrder={setOrder}
        length={length}
        start={start}
        setLength={setLength}
        setStart={setStart}
        totalRecords={totalRecords}
        displayRecords={displayRecords}
      />
    </div>
  );
}
